<script lang="ts">export default { name: 'NestedRouter' }; </script>
<template>
    <RouterView v-if="keepAlive" v-slot="{ Component, route, ...params }">
        <KeepAlive :exclude="exclude">
            <component :is="Component" :key="remountKey(Component, route)" v-bind="params" />
        </KeepAlive>
    </RouterView>
    <RouterView v-else />
</template>

<script lang="ts" setup>
import { PageNames } from '@/shared/page-names';

const props = withDefaults(defineProps<{
    keepAlive?: boolean;
    exclude?: string | string[]
}>(), {
    keepAlive: true,
    exclude: PageNames.PlayPage,
});

// Vue Router still reuses excluded components' instances across param-only navs,
// staling any setup-time closures over route params. Force a remount by keying on
// path (not fullPath, so query-only changes don't remount).
function remountKey(component: { name?: string, type?: { name?: string } }, route: { path: string }) {
    const name = component?.name ?? component?.type?.name;
    const excludeList = Array.isArray(props.exclude) ? props.exclude : [props.exclude];

    return name != null && excludeList.includes(name) ? route.path : undefined;
}
</script>
